export default {
  'component.tagSelect.expand': 'Développer',
  'component.tagSelect.collapse': 'Réduire',
  'component.tagSelect.all': 'Tout',
  'component.themeToggle.switchToLight': 'Passer au mode clair',
  'component.themeToggle.switchToDark': 'Passer au mode sombre',
};
